// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"8c477ebd","898":"4113b9fe"}[chunkId] + ".chunk.css";
};